import React, { useEffect, useState, useRef } from "react";
import SearchIcon from "./image/Search.png";
import "./Search.css";
import { useApp } from "../../../AppProvider";
import { Link } from "react-router-dom";
import ContactVerification from "../../../Components/Appointment/ContactVerification";
import Avatar from '@mui/material/Avatar';
import CloseIcon from '@mui/icons-material/Close';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import api from '../../../axiosInstance'
import logger from "../../../utils/logger";

const Search = ({ open, onClose }) => {
  const { setSelectedPatient, stringAvatar, stringToColor } = useApp();
  const [searchPatientsData, setSearchPatientsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isContactVerificationOpen, setIsContactVerificationOpen] = useState(false);

  const popupRef = useRef(null);

  const fetchSearchPatientsAPI = async (searchQuery) => {
    if (!open) return;

    try {

      const response = await api.get('/search/patients', {
        params: { searchQuery: searchQuery } 
      });
      logger.debug(response)
      setSearchPatientsData(response.data);
    } catch (error) {
      logger.error("Error fetching search patients data:", error.response?.data || error.message);
    }
  };

  useEffect(() => {
    if (open) {
      if (searchQuery.length >= 3) {
      fetchSearchPatientsAPI(searchQuery);
    }
    }
  }, [open, searchQuery]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    logger.debug(searchQuery)
    setSearchPatientsData([]);
    if (searchQuery.length >= 3) {
      fetchSearchPatientsAPI(searchQuery);
    }
  };

  const handleSelectPatient = (patient) => {
    setSearchQuery(`${patient.name.firstName} ${patient.name.lastName}`);
    setSelectedPatient(patient._id);
    setSearchPatientsData([]);
  };

  const openContactVerification = async () => {
    setIsContactVerificationOpen(true);
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      onClose();
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  function getEventColor(eventType) {
    switch (eventType) {
      case "New":
        return "new-bg-searchPop";
      case "Regular":
        return "regular-bg-searchPop";
      case "Critical":
        return "critical-bg-searchPop";
      case "Published":
        return "published-bg-searchPop";
      default:
        return "";
    }
  }

  function getTextColor(eventType) {
    switch (eventType) {
      case "New":
        return "new-searchPop";
      case "Regular":
        return "regular-searchPop";
      case "Critical":
        return "critical-searchPop";
      case "Published":
        return "published-searchPop";
      default:
        return "";
    }
  }

  return (
    <div className="search-main-background-overlay" ref={popupRef}>
      <div className="search-main-background">
        <div className="cross-icon_container" onClick={() => onClose()}>
          <CloseIcon />
        </div>
        <div className="searchpop">
          <SearchOutlinedIcon sx={{ fontSize: { md: '28px', lg: '28px', xl: '28px' } }} />
          <input
            className="searchtext"
            type="text"
            placeholder="Search Patient's"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
        <div className="search-data-show">
          {searchPatientsData.map((item, index) => (
            <Link
              to="/DashboardDashboardNavigation/history"
              className="search-card"
              key={index}
              onClick={() => handleSelectPatient(item)}
            >
              <div className="search-section-1">
                <Avatar sx={{ width: { md: 40, lg: 50, xl: 50 }, height: { md: 40, lg: 50, xl: 50 }, bgcolor: item.img ? 'transparent' : stringToColor(item.name.firstName) }}
                  alt={item.name.firstName}
                  src={item.img} >
                  {!item.img && stringAvatar(`${item.name.firstName}`).children}
                </Avatar>
                <div className="search-patient-info">
                  <p className="search-patient-name">{`${item.name.firstName} ${item.name.lastName}`}</p>
                  {(item.contact?.phoneNumber?.phoneNumber || item.phoneNumber) && (
                    <p className="search-patient-phone">{item.contact?.phoneNumber?.phoneNumber || item.phoneNumber}</p>
                  )}
                </div>
              </div>
              <div className="search-btn">
                <div className={`search-tag-button ${getEventColor(item.tag)} ${getTextColor(item.tag)}`}>
                  {item.tag}
                </div>
              </div>
            </Link>
          ))}
        </div>
        <button className="search-add-patient-button" onClick={openContactVerification}>Add Patient</button>
      </div>

      {isContactVerificationOpen &&
        <ContactVerification setIsContactVerificationOpen={setIsContactVerificationOpen} onClose={onClose} />
      }
    </div>
  );
};

export default Search;
